module.exports = "../images/tim.svg?df3f855062153cfd3be061ad9a694b34";